import { render, staticRenderFns } from "./game-layout.vue?vue&type=template&id=098dbfc1"
import script from "./game-layout.vue?vue&type=script&lang=js"
export * from "./game-layout.vue?vue&type=script&lang=js"
import style0 from "./game-layout.vue?vue&type=style&index=0&id=098dbfc1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports